import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useCloseModal, useCurrentModal } from '../../../components/modals/ModalsContext'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('triggers')
  const onClose = useCloseModal()
  const {
    data: { isClone, id }
  } = useCurrentModal()

  const context = isClone ? 'cloning' : !!id ? 'edit' : undefined
  const title = t('modalTitle', { context })

  return (
    <>
      <Grid justify="space-between">
        <Col flex={1}>
          <Title size="h5" strong color={COLORS.dark2} noMargin>
            {title}
          </Title>
        </Col>
        <Col>
          <Icon name="BsX" onClick={onClose} size={1.5} color="dark3" />
        </Col>
      </Grid>

      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
